const FETCH_TIMEOUT_MS = 5000;

export async function fetchLatestSha() {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
  try {
    // Raw fetch, not the app's axios instance: axios.defaults.baseURL points
    // at the API host (see src/config/setup/axiosSetup.js), and version.json
    // is served alongside the app bundle itself, not by the API.
    const response = await fetch('/version.json', {
      cache: 'no-store',
      signal: controller.signal,
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data && typeof data.sha === 'string' ? data.sha : null;
  } catch {
    return null;
  } finally {
    clearTimeout(timeout);
  }
}
